module.exports = __webpack_public_path__ + "img/Barlow-Regular.0d61f532.svg";